import React from 'react';
import Layout from 'components/Layout';
import styled from 'styled-components';
import { PHONE } from 'constants/measurements';
import { useQuery } from 'react-query';
import { Page } from 'types';
import CreateLiveWorkoutForm from 'components/CreateLiveWorkoutForm';
import { useLocation } from 'react-router-dom';
import { getPage } from 'queries/page';
import { ILiveWorkout } from 'types';
import { CircularProgress } from '@material-ui/core';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;

export const Wrap = styled.div`
  width: 500px;
  margin-top: 20px;
  @media (max-width: ${PHONE}) {
    margin-top: 10px;
    width: 90%;
  }
`;

const CreateWorkout = (props: any): React.ReactElement => {
  const { isLoading, data: pageQuery } = useQuery<Page, Error>(
    'creatorPage',
    () => getPage(),
  );
  const location = useLocation<{ workoutData: ILiveWorkout }>();

  if (isLoading || !pageQuery) {
    return (
      <Layout title="Edit Live Workout">
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '20px',
          }}
        >
          <CircularProgress />
        </div>
      </Layout>
    );
  }

  const liveConfig = pageQuery.config;

  const tags = liveConfig?.workoutTags;

  // TODO QueryParamMessage
  return (
    <Layout title="Edit Live Workout">
      <Container>
        <Wrap>
          {/* <QueryParamMessage /> */}
          <CreateLiveWorkoutForm
            types={tags || []}
            classPrices={liveConfig.classPrices}
            isEditing={true}
            workoutData={location.state.workoutData}
          />
        </Wrap>
      </Container>
    </Layout>
  );
};

export default CreateWorkout;
